export function ProductFaqCollapseInit() {
    const productFaqWrapperQuery = '.c-product-faq-wrapper';
    const buttonQuery = '#product-faq-less-more-button';

    /**
     * @type
     */
    const showHideButton = document.querySelector(buttonQuery);

    /**
     * @type {null | HTMLDivElement}
     */
    const productFaqWrapper = document.querySelector(productFaqWrapperQuery);

    if(showHideButton && productFaqWrapper){

        showHideButton.addEventListener('click', (el) => {
            if(productFaqWrapper.classList.contains('is-open')) {
                productFaqWrapper.classList.remove('is-open');
                el.target.innerText = 'Zobacz więcej';

            } else {
                productFaqWrapper.classList.add('is-open');
                el.target.innerText = 'Zobacz mniej';
            }
        })
    }

}
